<template>
  <!-- <el-autocomplete class="inline-input" :debounce="500" v-model="tjkName" :fetch-suggestions="tjkSearch" placeholder="姓名或淘金号或登录账号" @select="tjkHandleSelect" :trigger-on-focus="false" clearable></el-autocomplete> -->
  <el-select
    filterable
    remote
    clearable
    :remote-method="querySearch"
    v-model="tjkName"
    @clear="onClear"
    @change="onChange"
    placeholder="姓名或淘金号或登录账号">
    <el-option v-for="item in userList"
      :key="item.id"
      :label="item.label"
      :value="item.id"></el-option>
  </el-select>
</template>
<script>
  export default {
    name: 'tjkautocompleteall',
    data() {
      return {
        userList: [],
        tjkName: this.$route.query.tjkName?(this.$route.query.tjkName+'('+this.$route.query.tjkNumber+')'): ''
      }
    },
    props: ['tjkId'],
    watch: {
      tjkName: function() {
        if(this.tjkName == '') {
          this.$emit('change', '')
        }
      },
      tjkId: function() {
        if(this.tjkId == '') {
          this.tjkName = ''
        }
      }
    },
    methods: {
      querySearch(queryString) {
        var data = {
          'tjkParam': queryString
        }
        this.$http.post(API_ROOT.tjkuser + '/tjk/queryForAllType', data).then(response => {
          var result = response.data
          if(result.success) {
            this.userList = result.data.map(this.userWithLabel);
          }else {
            this.$alert(result.msg)
          }
        }, response => {
          this.$alert('网络繁忙，请稍后重试！')
        })
      },
      // 选中
      onChange(item) {
        this.$emit("change", item);
      },
      onClear() {
        this.$emit("change", '');
      },
      //淘金客姓名或登录账号模糊搜索
      tjkSearch(queryString, callback) {
        if((queryString !== '') && (queryString.length >= 2)) {
          var tjkList = []
          var data = {
            'tjkParam': queryString
          }
          this.$http.post(API_ROOT.system + '/tjk/queryForAllType', data).then(response => {
            var result = response.data
            if(result.success) {
              //在这里为这个数组中每一个对象加一个value字段, 因为autocomplete只识别value字段并在下拉列中显示  
              for(let i of response.data.data) {
                i.value = (i.realName?i.realName:"空")+'('+i.tjkNumber+')'
              }
              tjkList = result.data
              if(result.data.length > 0) {
                callback(tjkList)
              }else {
                callback([{'value':'无数据'}])
              }
            }else {
              alert(result.msg)
            }
          }, response => {
            alert('网络繁忙，请稍后重试！')
          })
        }
      },
      tjkHandleSelect(item) {
        this.$emit('callBack', item)
      },

      userWithLabel(user) {
        if ( !user ) {
          return user;
        }
        user.label = (user.realName?user.realName:"空")+'('+user.tjkNumber+')';
        return user;
      },
    }
  }
</script>

<style lang="less" scoped>
.el-scrollbar {
  li {
    font-size: 14px !important;
  }
}
</style>


// WEBPACK FOOTER //
// ./src/components/tjkAutoCompleteAll.vue